import { Users } from 'lucide-react'

import { type EmployeeInfo } from './EmployeeEntry'

type Props = {
  employee?: EmployeeInfo
}

export function EmployeeInfoEntryHeader ({ employee }: Props) {
  const displayName = employee?.first_name || employee?.last_name
    ? `${employee.first_name || ''} ${employee.last_name || ''}`.trim()
    : employee?.name || 'No name'

  return (
    <div className='flex flex-col gap-1'>
      <span className='body'>{displayName}</span>
      <div className='flex items-center gap-1'>
        <Users className='w-3 h-3 text-gray-500' />
        <span className='body-sm text-gray-500'>{employee?.dependents?.length || 0} dependent{employee?.dependents?.length === 1 ? '' : 's'}</span>
      </div>
    </div>
  )
}
